export default {
    computed: {
        $today() {
            return this.$store.state.today.value;
        },
    },
};